import VerifiedRefurbishedModal from './VerifiedRefurbishedModal.vue'

export default VerifiedRefurbishedModal
